import {
  TypographyElement,
  Row
} from 'UI'
import Text from './text.json'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Cards from 'components/Pricing/Cards'

const useStyle = createUseStyles(style)

export default ({
  phone
}) => {
  const theme = useTheme()
  const { satisfiedOrRefundedContainer, titleClass, subTitleClass } = useStyle()

  return (
    <>
      <Row justify='center' className={titleClass} repeatCols={1}>
        <TypographyElement
          variant='heading2'
          spacing='0 0 16px 0'
          align='center'
          Component='h2'
        >
          {Text.title}
        </TypographyElement>
      </Row>
      <Row justify='center' className={subTitleClass} repeatCols={1}>
        <TypographyElement
          spacing='0 0 32px 0'
          variant='body1'
          align='center'
        >
          {Text.subTitle1}
          <TypographyElement
            color={theme.primary[0]}
            display='inline'
            variant='body1'
            Component='a'
            cursor='pointer'
            href={`tel:${phone}`}
          >
            {` ${phone} `}
          </TypographyElement>
          {Text.subTitle2}
        </TypographyElement>
      </Row>
      <Cards isLearningPath showUnitPricing />
      <Row justify='center' className={satisfiedOrRefundedContainer} repeatCols={1}>
        <TypographyElement
          variant='body1'
          align='center'
          color={theme.primary[0]}
        >
          {Text.satisfiedOrRefunded}
        </TypographyElement>
      </Row>
    </>
  )
}
